// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1_MU5","cls2":"RatingCard-cls2_Np_ RatingCard-cls1_MU5"};